import { Component, OnInit } from '@angular/core';
import { FadeinAnimation } from '@core/animations/fadein.animation';
@Component({
  selector: 'app-main-loader',
  templateUrl: './main-loader.component.html',
  styleUrls: ['./main-loader.component.scss'],
  animations: [FadeinAnimation],
})
export class MainLoaderComponent implements OnInit {
  constructor() {
  }
  ngOnInit(): void {
  }
}
